import Vue from 'vue';
import urlFactory from '@tencent/vft-common/urlFactory';
import tenvideo from '@tencent/vft-common/tenvideo';

const normalizer = urlFactory.createNormalizer();

Vue.directive('url', {
  inserted(el, binding) {
    if (binding.modifiers.stop) {
      $(el).on('click', (e) => {
        e.stopPropagation();
        handler(e);
      });
    } else {
      $(el).on('click', '[href],[url]', handler);
    }
    function handler(e) {
      const $target = $(e.currentTarget);

      let url = $target.attr('href') || $target.attr('url');

      const needOpenInApp = $target.attr('needOpenInApp');
      e.preventDefault();
      if (!/^(http:|https:|\/\/)/.test(url)) {
        return false;
      }
      url = normalizer(url, location.protocol);
      if (tenvideo.isAllTenvideo() && binding.modifiers.ignoreApp !== true) {
        tenvideo.openUrl(url);
      } else {
        if (needOpenInApp) {
          try {
            openApp(url);
          } catch (e) {
            location.href = url;
          }
        } else {
          location.href = url;
        }
      }
    }
  },
});

function openApp(link) {
  let url = link;
  let tenvideoUrl = url;

  if (/^\/\//.test(url)) {
    url = `https:${url}`;
  }

  if (/^(tenvideo2|txvideo)/.test(url)) {
    tenvideoUrl = url;
  } else if (/^(?:https:|http:)?\/\/([\w\-_.]*)film\.qq\.com/.test(url)) {
    tenvideoUrl = `txvideo://v.qq.com/HollywoodH5Activity?url=${encodeURIComponent(url)}`;
  } else if (/^(?:https:|http:)?\/\//.test(url)) {
    tenvideoUrl = `tenvideo2://?action=10&openurl=${encodeURIComponent(url)}`;
  }
  location.href = `https://film.qq.com/weixin/v3/openapp/index.html?url=${encodeURIComponent(tenvideoUrl)}`;
}
